import NoImage from 'assets/images/noimage.png'
import PMBTabSwitcher from 'components/PMBTabSwitcher'
import { capitalizeEveryWord } from 'helpers'
import useIsMobile from 'hooks/useIsMobile'
import { useEffect, useState } from 'react'
import { Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import { formatDatePMB } from 'utils/formatDate'
import TabSchemaList from './TabSchemaList'

const ModalDetailMasterItem = ({ isOpen, toggle, itemData }) => {
  const [activeTab, setActiveTab] = useState('info')
  const isMobile = useIsMobile()

  const tabs = [
    { key: 'info', label: 'Barang' },
    { key: 'schema', label: 'Map Skema' },
  ]

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey)
  }

  useEffect(() => {
    if (isOpen) {
      setActiveTab('info')
    }
  }, [isOpen])

  if (!itemData) return null

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered={!isMobile}
      fullscreen={isMobile ? true : undefined}
      style={!isMobile ? { maxWidth: '800px' } : undefined}
      className={isMobile ? 'modal-fullscreen-mobile' : ''}
      data-testid="master-item-modal-detail"
    >
      <ModalHeader
        toggle={toggle}
        className="border-bottom sticky-top bg-white"
        style={{ zIndex: 1000 }}
      >
        <div className="w-100">
          <div
            className={`d-flex align-items-center gap-2 ${isMobile ? 'flex-column align-items-start' : 'mb-1'}`}
          >
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <span className={`fw-bold ${isMobile ? 'fs-6' : ''}`}>
                {itemData?.nameItem}
              </span>
            </div>
          </div>
          {!isMobile && (
            <p className="text-muted mb-0" style={{ fontSize: '0.875rem' }}>
              Lihat informasi lengkap dan map skema barang
            </p>
          )}
        </div>
      </ModalHeader>
      <ModalBody className={isMobile ? 'p-2' : ''}>
        <PMBTabSwitcher
          activeTab={activeTab}
          tabs={tabs}
          onTabChange={handleTabChange}
          boldLabel={false}
          labelSize="regular"
          testId="schema-tab"
        />

        <div className={isMobile ? 'mt-2' : 'mt-4'}>
          {activeTab === 'info' && (
            <>
              {!isMobile && (
                <div className="alert alert-info mb-4 small">
                  <strong>💡 Tips:</strong> Untuk melihat atau menambah map
                  skema, silakan klik tab <strong>"Map Skema"</strong> di atas
                </div>
              )}

              <Row className="g-4 align-items-start">
                {/* IMAGE SECTION */}
                <Col xs={12} md={4}>
                  <div className="d-flex justify-content-center">
                    <img
                      src={
                        itemData?.linkFoto && itemData.linkFoto.length > 0
                          ? itemData.linkFoto
                          : NoImage
                      }
                      alt={itemData?.nameItem}
                      className="w-100"
                      style={{
                        maxHeight: isMobile ? '220px' : '300px',
                        objectFit: 'contain',
                        borderRadius: '10px',
                        border: '1px solid #E0E0E0',
                        backgroundColor: '#FAFAFA',
                      }}
                    />
                  </div>
                </Col>

                {/* INFO SECTION */}
                <Col xs={12} md={8}>
                  <div className="d-flex flex-column gap-3">
                    <div>
                      <label className="text-muted small mb-1 d-block">
                        Nama Barang
                      </label>
                      <h5
                        className={`fw-semibold mb-0 text-primary ${isMobile ? 'fs-6' : ''}`}
                      >
                        {itemData?.nameItem}
                      </h5>
                    </div>

                    <div>
                      <label className="text-muted small mb-1 d-block">
                        Satuan
                      </label>
                      <p className={`mb-0 ${isMobile ? 'small' : ''}`}>
                        {capitalizeEveryWord(itemData?.unit || '-')}
                      </p>
                    </div>

                    <div>
                      <label className="text-muted small mb-1 d-block">
                        Tanggal
                      </label>
                      <p className={`mb-0 ${isMobile ? 'small' : ''}`}>
                        {formatDatePMB(
                          itemData?.createdAt,
                          itemData?.createdAt,
                        )}
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </>
          )}

          {activeTab === 'schema' && (
            <TabSchemaList
              itemId={itemData?.id}
              itemName={itemData?.nameItem}
            />
          )}
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalDetailMasterItem
